import NextLink from 'next/link'
import {
  ContentBlocks,
  contentBlocksQuery,
} from '@/components/contentBlocks/ContentBlocks'
import { Hero } from '@/components/Hero'
import { statamicGraphqlEndpoint } from '@/globals/globals'
import { Card } from '@/pages/downloads'
import { Box, Container, SimpleGrid } from '@chakra-ui/react'
import request, { gql } from 'graphql-request'
import { GetStaticPaths, GetStaticProps } from 'next'

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export const getStaticProps: GetStaticProps = async context => {
  // Return 404 if no slug is passed
  if (!context.params?.slug) {
    return {
      notFound: true,
    }
  }

  const data = await request(
    statamicGraphqlEndpoint,
    gql`
      query MyQuery($slug: String) {
        entry(collection: "downloads", slug: $slug) {
          ... on Entry_Downloads_Downloads {
            id
            slug
            title
            ${contentBlocksQuery}
          }
        }
        entries(collection: "downloads") {
          data {
            ... on Entry_Downloads_Downloads {
              id
              title
              slug
              thumbnail {
                ... on Asset_Main {
                  id
                  url
                  width
                  height
                }
              }
            }
          }
        }
      }

    `,
    {
      slug: context.params.slug,
    }
  )

  return {
    props: {
      data: data,
    },
    revalidate: 60,
  }
}

export const Page = ({ data }: any) => {
  return (
    <>
      <Hero
        label='Downloads'
        heading={data.entry.title}
        subheading={data.entry.intro}
      />
      <Box pb={20}>
        <ContentBlocks {...data.entry} />
      </Box>
      <Container py={20} maxWidth='6xl'>
        <SimpleGrid columns={{ base: 1, md: 2 }} gap={{ base: 6, xl: 12 }}>
          {data.entries?.data?.map((item: any) =>
            item.slug !== data.entry.slug ? (
              <Box key={item.id}>
                <NextLink
                  href={`/downloads/${item.slug}`}
                  passHref
                  legacyBehavior>
                  <a>
                    <Card item={item} />
                  </a>
                </NextLink>
              </Box>
            ) : null
          )}
        </SimpleGrid>
      </Container>
    </>
  )
}

export default Page
